export const PREORDER_INVENTORY = 'PRE_ORDER'
// @i18n-ignore
export const NORMAL_INVENTORY = 'NORMAL'

export const SP_API = 'SP_API'
export const INTERNAL_INVENTORY_API = 'INTERNAL_INVENTORY_API'

export type InventoryType = typeof PREORDER_INVENTORY | typeof NORMAL_INVENTORY
export type InventoryInfoSourceType = typeof SP_API | typeof INTERNAL_INVENTORY_API

export interface SvDetails {
  id: number
  quantityAvailable: number
  price: number
  inventoryType?: InventoryType
  preOrderShippingDate?: string
  inventoryInfoSource: InventoryInfoSourceType
  isInventoryPresentAtSFWarehouse?: boolean
}

export interface IProductPurchaseInfo {
  svidShowMTOMap: Record<number, boolean>
  svidVsSvDetails: Record<number, SvDetails>
}
